const initialState = {
  success: false,
  userSuccess: false,
  login: false,
  loading: false,
  error: null,
  loggedIn: false,
  successMessage: null,
  currentUser: {
    data: null,
    loading: false,
    buttonLoading: false,
    error: null,
    passwordError: null,
    forcedLogout: false,
  },
  users: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  logs: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
  adminLogs: {
    data: [],
    pagination: {},
    loading: false,
    error: null,
  },
};

const userReducer = (
  state = initialState,
  { obj, type, error, payload, data, pagination }
) => {
  switch (type) {
    case "RESET_USER":
      return initialState;

    case "SIGNUP":
    case "LOGIN":
    case "LOGOUT":
      return {
        ...state,
        ...initialState,
        type,
        loading: true,
      };

    case "SIGNUP_SUCCESS":
      return {
        ...state,
        loading: false,
        signUpSuccess: true,
        type,
        payload,
        currentUser: {
          ...state.currentUser,
          loading: false,
          error: null,
        },
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        ...initialState,
        type,
        loading: false,
        loggedIn: false,
      };

    case "LOGIN_SUCCESS":
      return {
        ...state,
        login: true,
        success: true,
        loading: false,
        type,
        payload,
        loggedIn: true,
        currentUser: {
          ...state.currentUser,
          loading: false,
          // forcedLogout: false,
          data,
        },
      };

    case "LOGIN_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        currentUser: {
          ...state.currentUser,
          loading: false,
          error,
        },
      };
    case "FORGOT_PASSWORD":
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };
    case "FORGOT_PASSWORD_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
      };
    case "FORGOT_PASSWORD_FAIL":
      return {
        ...state,
        loading: false,
        success: false,
        error,
      };
    case "UPDATE_PASSWORD":
      return {
        ...state,
        successMessage: null,
        loading: true,
        currentUser: {
          ...state.currentUser,
          passwordError: null,
          buttonLoading: true,
        },
      };
    case "UPDATE_PASSWORD_SUCCESS":
      return {
        ...state,
        login: true,
        success: true,
        loading: false,
        type,
        payload,
        loggedIn: true,
        successMessage: "Password successfully updated.",
        currentUser: {
          ...state.currentUser,
          buttonLoading: false,
          success:true,
        },
      };

    case "UPDATE_PASSWORD_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        currentUser: {
          ...state.currentUser,
          buttonLoading: false,
          passwordError: error,
          success:false,
        },
      };
    case "UPDATE_PHONE_ADDRESS":
      return {
        ...state,
        successMessage: null,
        currentUser: {
          ...state.currentUser,
          error: null,
          buttonLoading: true,
        },
      };
    case "UPDATE_PHONE_ADDRESS_SUCCESS":
      return {
        ...state,
        login: true,
        success: true,
        loading: false,
        type,
        payload,
        loggedIn: true,
        successMessage: "User details successfully updated.",
        currentUser: {
          ...state.currentUser,
          buttonLoading: false,
        },
      };

    case "UPDATE_PHONE_ADDRESS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        currentUser: {
          ...state.currentUser,
          buttonLoading: false,
          error,
        },
      };

    case "SIGNUP_FAIL":
    case "LOGOUT_FAIL":
      return {
        ...state,
        error,
        success: false,
        loading: false,
        type,
      };

    case "GET_CURRENT_USER":
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          loading: true,
          error: null,
          data: null,
        },
      };

    case "GET_CURRENT_USER_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        loggedIn: true,
        currentUser: {
          ...state.currentUser,
          data: data,
          loading: false,
          error: null,
        },
      };

    case "GET_CURRENT_USER_FAIL":
      return {
        ...state,
        loggedIn: false,
        currentUser: {
          ...state.currentUser,
          loading: false,
        },
      };

    case "GET_TAX_INSPECTORS":
      return {
        ...state,
        type,
        error: null,
        users: {
          ...initialState.users,
          loading: true,
        },
      };

    case "GET_TAX_INSPECTORS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        users: {
          ...state.users,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_TAX_INSPECTORS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        users: {
          ...state.users,
          loading: false,
          error,
        },
      };

    case "ADD_TAX_INSPECTORS":
      return {
        ...state,
        type,
        error: null,
        users: {
          ...state.users,
          loading: true,
        },
      };

    case "ADD_TAX_INSPECTORS_SUCCESS":
      return {
        ...state,
        userSuccess: true,
        loading: false,
        type,
        payload,
      };

    case "ADD_TAX_INSPECTORS_FAIL":
      return {
        ...state,
        userSuccess: false,
        loading: false,
        type,
        error,
        users: {
          ...state.users,
          loading: false,
        },
      };

    case "EDIT_TAX_INSPECTORS":
      return {
        ...state,
        error: null,
        loading: true,
        type,
      };

    case "EDIT_TAX_INSPECTORS_SUCCESS":
      return {
        ...state,
        userSuccess: true,
        loading: false,
        type,
        payload,
        users: {
          ...state.users,
          data: state.users.data.map((userToUpdate) => {
            data.data.map((userFromResponse) => {
              if (userToUpdate.id === userFromResponse.id) {
                userToUpdate = userFromResponse;
              }
            });
            let updatedUser = { ...userToUpdate };
            return updatedUser;
          }),
        },
      };

    case "EDIT_TAX_INSPECTORS_FAIL":
      return {
        ...state,
        userSuccess: false,
        loading: false,
        type,
        error,
        users: {
          ...state.users,
          loading: false,
        },
      };

    case "GET_USERS_SURVEYS":
      return {
        ...state,
        type,
        error: null,
        users: {
          ...initialState.users,
          loading: true,
        },
      };

    case "GET_USERS_SURVEYS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        users: {
          ...state.users,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_USERS_SURVEYS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        users: {
          ...state.users,
          loading: false,
          error,
        },
      };

    case "CLEAR_USER_SUCCESS":
      return {
        ...state,
        userSuccess: false,
        error: null,
        type,
      };
    case "UPDATE_SURVEY_STATUS":
      return {
        ...state,
        type,
        error: null,
        currentUser: {
          ...initialState.currentUser,
          loading: true,
        },
      };

    case "UPDATE_SURVEY_STATUS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        currentUser: {
          ...state.currentUser,
          loading: false,
          data: data.data,
        },
      };

    case "UPDATE_SURVEY_STATUS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        currentUser: {
          ...state.currentUser,
          loading: false,
          error,
        },
      };
    case "GET_ACTIVITY_LOGS":
      return {
        ...state,
        type,
        error: null,
        logs: {
          ...initialState.logs,
          loading: true,
        },
      };

    case "GET_ACTIVITY_LOGS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        logs: {
          ...state.logs,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_ACTIVITY_LOGS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        logs: {
          ...state.logs,
          loading: false,
          error,
        },
      };
    case "GET_ADMIN_ACTIVITY_LOGS":
      return {
        ...state,
        type,
        error: null,
        adminLogs: {
          ...initialState.adminLogs,
          loading: true,
        },
      };

    case "GET_ADMIN_ACTIVITY_LOGS_SUCCESS":
      return {
        ...state,
        success: true,
        loading: false,
        type,
        payload,
        adminLogs: {
          ...state.adminLogs,
          loading: false,
          data: data.data,
          pagination: { ...data.pagination },
        },
      };

    case "GET_ADMIN_ACTIVITY_LOGS_FAIL":
      return {
        ...state,
        success: false,
        loading: false,
        type,
        adminLogs: {
          ...state.adminLogs,
          loading: false,
          error,
        },
      };
    case "FORCED_LOGOUT":
      return {
        ...state,
        type,
        error: null,
        currentUser: {
          ...state.currentUser,
          forcedLogout: true,
        },
      };
    default:
      return state;
  }
};

export default userReducer;
